<template>
    <v-snackbar
          :timeout="3000"
          bottom
          center
          :color="snackbar.color"
          v-model="snackbar.show"
        >
            {{ snackbar.text }}
        <v-btn dark flat @click.native="snackbar.show = false" icon> 
          <v-icon>close</v-icon>
        </v-btn>
    </v-snackbar>   
</template>

<script>
export default {
  name: 'app-snackbar',
  data() {
    return {            
        snackbar: {
            show : false,
            text : '',
            color: '',
        }               
    }
  },  
  methods: {
    
  },
  created () {
    window.getApp.$on('showSnackbar', (snackbar) => {
        Object.assign(this.snackbar, snackbar);      
    });
  },
};
</script>
<style>
.v-snack {
  font-family: 'Roboto', sans-serif;
}
</style>